export const LoginErrorCode = {
  InvalidCredentials: 'INVALID_CREDENTIALS',
  TooManyAttempts: 'TOO_MANY_LOGIN_ATTEMPTS',
  TemporarilyUnavailable: 'LOGIN_TEMPORARILY_UNAVAILABLE',
  TwoFactorSetupRequired: 'TWO_FACTOR_SETUP_REQUIRED',
  Failed: 'LOGIN_FAILED',
} as const;

export type LoginErrorCodeValue = (typeof LoginErrorCode)[keyof typeof LoginErrorCode];

export function resolveLoginErrorCode(
  payloadErrorCode?: string | null,
  graphQlMessages: readonly string[] = [],
): LoginErrorCodeValue {
  if (payloadErrorCode === LoginErrorCode.TwoFactorSetupRequired) {
    return LoginErrorCode.TwoFactorSetupRequired;
  }

  const messages = graphQlMessages.map((message) => message.toLowerCase());

  if (messages.some((message) => message.includes('invalid credentials'))) {
    return LoginErrorCode.InvalidCredentials;
  }

  if (messages.some((message) => message.includes('too many login attempts'))) {
    return LoginErrorCode.TooManyAttempts;
  }

  if (messages.some((message) => message.includes('temporarily unavailable'))) {
    return LoginErrorCode.TemporarilyUnavailable;
  }

  return LoginErrorCode.Failed;
}

export function getLoginErrorTranslationKey(errorCode?: string): string {
  switch (errorCode) {
    case LoginErrorCode.InvalidCredentials:
      return 'login.invalidCredentials';
    case LoginErrorCode.TooManyAttempts:
      return 'login.tooManyAttempts';
    case LoginErrorCode.TemporarilyUnavailable:
      return 'login.temporarilyUnavailable';
    case LoginErrorCode.TwoFactorSetupRequired:
      return 'login.twoFactorSetupRequired';
    default:
      return 'login.loginFailed';
  }
}
